import script from "./ChatConnectionView.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatConnectionView.vue?vue&type=script&setup=true&lang=js"

import "./ChatConnectionView.vue?vue&type=style&index=0&id=372644e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-372644e8"]])

export default __exports__